import { queryClient, recoverShellGate } from '@/utils/reactQueryClient';
import { createRolesController, type CatalogModuleDto } from '@saas/api-client';
import { globalAuthRequestFunction } from '../http/request';
import { makeQuery } from '../http/queryUtils';

export type PermissionKey = NonNullable<CatalogModuleDto['read']>;

type RolesCtrl = ReturnType<typeof createRolesController>;

export const permissionsServiceKeys = {
	base: 'PERMISSIONS',
	myEffectivePermissions: (params: Parameters<RolesCtrl['myEffectivePermissions']>[0]) =>
		[permissionsServiceKeys.base, 'myEffectivePermissions', params] as const,
	catalog: (params: Parameters<RolesCtrl['getCatalog']>[0]) =>
		[permissionsServiceKeys.base, 'catalog', params] as const,
};

export const invalidatePermissionQueries = {
	all: () => queryClient.invalidateQueries({ queryKey: [permissionsServiceKeys.base] }),
	myEffectivePermissions: () =>
		queryClient.invalidateQueries({ queryKey: [permissionsServiceKeys.base, 'myEffectivePermissions'] }),
	catalog: () => queryClient.invalidateQueries({ queryKey: [permissionsServiceKeys.base, 'catalog'] }),
};

// Prefetchable via `useMyEffectivePermissions.queryOptions` (see makeQuery).
const useMyEffectivePermissions = makeQuery({
	queryFunction: createRolesController(globalAuthRequestFunction).myEffectivePermissions,
	queryKeyFactory: (params) => [...permissionsServiceKeys.myEffectivePermissions(params)],
	defaultOptions: { retryOnMount: false, refetchInterval: recoverShellGate },
});

const useGetPermissionCatalog = makeQuery({
	queryFunction: createRolesController(globalAuthRequestFunction).getCatalog,
	queryKeyFactory: (params) => [...permissionsServiceKeys.catalog(params)],
});

export const permissionsService = {
	useMyEffectivePermissions,
	useGetPermissionCatalog,
};
